export function byId(arr: any[], fn: Function = null) {
    const obj = {};
    arr.forEach(x => {
      const id = fn ? fn(x) : x.id;
      obj[id] = x;
    });
    return obj;
  };
